import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

// ---------- AUTO-REFRESH INTERCEPTOR ----------
// On 401, try to refresh the access token once, then retry the original request.
// This keeps the user logged in across long sessions and app restarts.
let _refreshPromise = null;

api.interceptors.response.use(
    (r) => r,
    async (error) => {
        const original = error.config;
        const status = error.response?.status;
        const url = original?.url || "";

        // Don't try to refresh on auth endpoints themselves
        if (
            status === 401 &&
            original &&
            !original._retried &&
            !url.includes("/auth/login") &&
            !url.includes("/auth/register") &&
            !url.includes("/auth/refresh") &&
            !url.includes("/auth/logout")
        ) {
            original._retried = true;
            try {
                if (!_refreshPromise) {
                    _refreshPromise = api.post("/auth/refresh", {}).finally(() => {
                        _refreshPromise = null;
                    });
                }
                await _refreshPromise;
                return api(original);
            } catch {
                // Refresh failed → propagate original 401
            }
        }

        // 402 (subscription expired/canceled): redirect to /billing automatically
        if (status === 402 && typeof window !== "undefined") {
            if (!window.location.pathname.startsWith("/billing")) {
                window.location.href = "/billing";
            }
        }

        return Promise.reject(error);
    }
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Si è verificato un errore. Riprova.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const fmtEur = (n) =>
    new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const fmtDate = (s) => {
    if (!s) return "-";
    const d = new Date(s);
    if (isNaN(d)) return s;
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
